var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67135 4.10208L6.11302 0.660416C6.21996 0.553472 6.35608 0.5 6.52135 0.5C6.68663 0.5 6.82274 0.553472 6.92969 0.660416C7.03663 0.767361 7.0901 0.903472 7.0901 1.06875C7.0901 1.23403 7.03663 1.37014 6.92969 1.47708L3.07969 5.32708C2.96302 5.44375 2.82691 5.50208 2.67135 5.50208C2.5158 5.50208 2.37969 5.44375 2.26302 5.32708L0.746354 3.81042C0.639409 3.70347 0.585938 3.56736 0.585938 3.40208C0.585938 3.23681 0.639409 3.10069 0.746354 2.99375C0.853298 2.88681 0.98941 2.83333 1.15469 2.83333C1.31997 2.83333 1.45608 2.88681 1.56302 2.99375L2.67135 4.10208Z",
    fill: "#DDEFE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.c19d38cbfec59bd2f157ac066d7d3d6c.svg";
export { ForwardRef as ReactComponent };